import { GDPR_VALUE, NOT_AVAILABLE_VALUE, OFF_VALUE, PAID_VALUE } from '../../CmdTable/constants';

interface ISectionEcoDriveCellProps {
  value: string;
}

function SectionEcoDriveCell(props: ISectionEcoDriveCellProps): JSX.Element {
  const getElement = (): JSX.Element | null => {
    let element: JSX.Element | null = null;

    if (
      props.value === PAID_VALUE ||
      props.value === OFF_VALUE ||
      props.value === NOT_AVAILABLE_VALUE
    ) {
      return <>&ndash;</>;
    }
    if (props.value === GDPR_VALUE) {
      return <i className="cmd-icons cmd-icon-gdpr-document-lock-dark-gray" />;
    }

    if (Number(String(props.value).replace(',', '.')) < 5) {
      element = <strong className="text-c-red">{props.value || '-'}</strong>;
    } else if (Number(String(props.value).replace(',', '.')) < 8) {
      element = <strong className="text-c-orange">{props.value || '-'}</strong>;
    } else {
      element = <strong className="text-c-green-dark">{props.value || '-'}</strong>;
    }

    return element;
  };

  return (
    <div
      className={`align-middle text-right justify-content-${
        props.value === GDPR_VALUE ? 'center' : 'end'
      }`}
      style={{ minWidth: '88px', maxWidth: '88px', flex: 1 }}
    >
      {getElement()}
    </div>
  );
}

export default SectionEcoDriveCell;
